import React, { Component } from "react";
import CertifyTestContainer from "./CertifyTests";
import CertifyOOUContainer from "./CertifyOOU";
import CertifyBlueCard from "./CertifyBlueCard";

class InvalidTypeComponent extends Component {
  constructor(props) {
    super(props);
  }
  componentDidMount() {
    console.log(`❌ Invalid or missing 'type' prop in component. Received: '${this.props.type}'. Expected one of: 'test' or 'oou'.`);
  }
  render() {
    return null;
  }
}

class CertifyContainer extends Component {
  render() {
    const { type } = this.props;

    switch (type) {
      case "oou":
        return <CertifyOOUContainer {...this.props} />;
      case "test":
        return <CertifyTestContainer {...this.props} />;

      case "blueCard":
        return <CertifyBlueCard {...this.props} />;
      default:
        return <InvalidTypeComponent type={type} />;
    }
  }
}

export default CertifyContainer;



// WEBPACK FOOTER //
// ./src/components/BlueCardReport/BlueCardReportView/CertifyTest/CertifyContainer.jsx